import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Safety.module.css';

const Safety = () => {
  const [activeTab, setActiveTab] = useState('all');
  const { safetyCases, openSafetyCount } = useData();

  const highCount = safetyCases.filter((c) => c.severity.label === 'High').length;
  const mediumCount = safetyCases.filter((c) => c.severity.label === 'Medium').length;

  const tabs = [
    { id: 'all', label: 'All cases' },
    { id: 'open', label: 'Open', count: openSafetyCount },
    { id: 'high', label: 'High severity', count: highCount },
    { id: 'medium', label: 'Medium', count: mediumCount }
  ];

  const filteredCases = safetyCases.filter((c) => {
    if (activeTab === 'high') return c.severity.label === 'High';
    if (activeTab === 'medium') return c.severity.label === 'Medium';
    if (activeTab === 'open') return c.status.label === 'Open' || c.status.label === 'Investigating';
    return true;
  });

  const headerActions = (
    <Link to="/settings">
      <Button variant="secondary">Detection rules</Button>
    </Link>
  );

  return (
    <>
      <PageHeader
        title="Trust & safety"
        subtitle="Fraud signals, policy violations and account actions."
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Open cases" value={openSafetyCount} subtext={`${highCount} high severity`} />
        <MetricCard label="Accounts suspended" value="17" subtext="this month" />
        <MetricCard label="Incentives recovered" value="₹9,600" subtext="clawed back" isGreen />
        <MetricCard label="Duplicate-device hits" value="31" subtext="last 30 days" />
      </MetricRow>

      <div style={{ marginTop: '20px' }}>
        <FilterTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Case</div>
          <div>Signal</div>
          <div>Accounts</div>
          <div>Severity</div>
          <div>Raised</div>
          <div>Status</div>
          <div></div>
        </div>

        {filteredCases.map((c) => (
          <div key={c.id} className={styles.tableRow}>
            <div>
              <span className={styles.caseId}>{c.id}</span>
            </div>
            <div className={styles.signalText}>{c.signal}</div>
            <div className={styles.accountsText}>{c.accounts}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: c.severity.color, background: c.severity.bg }}
              >
                {c.severity.label}
              </span>
            </div>
            <div className={styles.raisedText}>{c.raised}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: c.status.color, background: c.status.bg }}
              >
                {c.status.label}
              </span>
            </div>
            <div>
              <Link to="/fraud-case" className={styles.openLink}>
                Open →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Safety;
